import React, { useState } from "react";
import { FaArrowLeft, FaSave } from "react-icons/fa";
import AdminAppBody from "../../../../components/admin/AdminAppBody";
import PageHeading from "../../../../components/admin/common/PageHeading";
import { IoTrashBin } from "react-icons/io5";

const AddTask = () => {
  const [program, setProgram] = useState("");
  const [selectedProgram, setSelectedProgram] = useState("");
  const [module, setModule] = useState("");
  const [topic, setTopic] = useState("");
  const [tasks, setTasks] = useState([]);

  const handleAddTask = () => {
    setTasks([...tasks, { taskName: "", summary: "" }]);
  };

  const handleTaskChange = (index, field, value) => {
    const updatedTasks = [...tasks];
    updatedTasks[index][field] = value;
    setTasks(updatedTasks);
  };

  const handleRemoveTask = (indexToRemove) => {
    const updatedTasks = tasks.filter((_, index) => index !== indexToRemove);
    setTasks(updatedTasks);
  };

  const handleSaveAllTasks = () => {
    console.log("Saving tasks:", {
      program,
      selectedProgram,
      module,
      topic,
      tasks,
    });
    alert("Tasks saved!");
  };

  return (
    <AdminAppBody
      content={
        <div className="container">
          <PageHeading title="Add Task" subTitle="Assign the Task." />

          <form className="shadow-lg p-4">
            <h6 className="fw-semibold mb-4">Task Form</h6>

            <div className="row">
              {/* Selectable Fields */}
              <div className="col-12 col-md-6 mb-3">
                <label htmlFor="program" className="form-label">
                  Program
                </label>
                <select
                  id="program"
                  className="form-select py-2"
                  value={program}
                  onChange={(e) => setProgram(e.target.value)}
                >
                  <option value="">Select</option>
                  <option value="Program 1">Program 1</option>
                  <option value="Program 2">Program 2</option>
                </select>
              </div>

              <div className="col-12 col-md-6 mb-3">
                <label htmlFor="selectedProgram" className="form-label">
                  Selected Program
                </label>
                <select
                  id="selectedProgram"
                  className="form-select py-2"
                  value={selectedProgram}
                  onChange={(e) => setSelectedProgram(e.target.value)}
                >
                  <option value="">Select</option>
                  <option value="SP 1">SP 1</option>
                  <option value="SP 2">SP 2</option>
                </select>
              </div>

              <div className="col-12 col-md-6 mb-3">
                <label htmlFor="module" className="form-label">
                  Module
                </label>
                <select
                  id="module"
                  className="form-select py-2"
                  value={module}
                  onChange={(e) => setModule(e.target.value)}
                >
                  <option value="">Select</option>
                  <option value="Module 1">Module 1</option>
                  <option value="Module 2">Module 2</option>
                </select>
              </div>

              <div className="col-12 col-md-6 mb-3">
                <label htmlFor="topic" className="form-label">
                  Topic
                </label>
                <select
                  id="topic"
                  className="form-select py-2"
                  value={topic}
                  onChange={(e) => setTopic(e.target.value)}
                >
                  <option value="">Select</option>
                  <option value="Topic 1">Topic 1</option>
                  <option value="Topic 2">Topic 2</option>
                </select>
              </div>
            </div>

            {/* Add Task Button */}
            <div className="mb-4">
              <button type="button" className="RVBtn" onClick={handleAddTask}>
                Add Task
              </button>
            </div>

            {/* Render Task Cards */}
            {tasks.map((task, index) => (
              <div
                key={index}
                className="card p-3 mb-3 shadow-sm border border-light"
              >
                <div className="row">
                  <div className="col-12 col-md-6 mb-3">
                    <label className="form-label">Task Name</label>
                    <input
                      type="text"
                      className="form-control py-2"
                      placeholder="Enter Task Name"
                      value={task.taskName}
                      onChange={(e) =>
                        handleTaskChange(index, "taskName", e.target.value)
                      }
                    />
                  </div>

                  <div className="col-12 col-md-6 mb-3">
                    <label className="form-label">Summary</label>
                    <textarea
                      className="form-control py-2"
                      placeholder="Enter Summary"
                      rows={3}
                      value={task.summary}
                      onChange={(e) =>
                        handleTaskChange(index, "summary", e.target.value)
                      }
                    ></textarea>
                  </div>
                </div>

                <div className="text-end">
                  <button
                    type="button"
                    className="removeRVBtn"
                    onClick={() => handleRemoveTask(index)}
                  >
                    <IoTrashBin />
                    </button>
                </div>
              </div>
            ))}

            {/* Icon-Only Action Buttons */}
            <div className="d-flex flex-column flex-md-row justify-content-between gap-3 mt-4">
              <button
                type="button"
                className="RVBtn"
                onClick={handleSaveAllTasks}
                title="Save"
              >
                <FaSave />
              </button>
            </div>
          </form>
        </div>
      }
    />
  );
};

export default AddTask;
